export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

export const languageChangeAction = (locale: string): any => ({
  type: LANGUAGE_CHANGE,
  locale
});
